import { render, staticRenderFns } from "./DeliveryDetailProof.vue?vue&type=template&id=16d5c8d4&scoped=true&"
import script from "./DeliveryDetailProof.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailProof.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetailProof.vue?vue&type=style&index=0&id=16d5c8d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d5c8d4",
  null
  
)

export default component.exports